<nb-card>
  <nb-card-header class="d-flex pb-0 pe-3">
    <morva-icons icon="warning"></morva-icons>
    <span class="text me-1">هشدار</span>
  </nb-card-header>
  <nb-card-body>
    <p class="text m-0">در حال حاضر حساب شما در دستگاه دیگری فعال است.</p>
    <p class="text m-0">
      با ورود در این دستگاه، نشست فعال قبلی پایان می‌یابد و از آن دستگاه خارج
      خواهید شد.
    </p>
    <p class="text">آیا مایل به ادامه هستید؟</p>
    <div
      class="
        nb-card-footer
        d-flex
        align-items-center
        justify-content-center
        gap-3
      "
    >
      <button nbButton class="cancel-button" (click)="close()">انصراف</button>
      <button
      data-testid="confirm-button"
        nbButton
        nbSpinnerStatus="basic"
        class="confirm-button"
        (click)="continue()"
      >
        ادامه
      </button>
    </div>
  </nb-card-body>
</nb-card>
